import { downloadFile } from './downloadFile';
import { exportDocumentToCsv } from './exportDocumentToCsv';
export function downloadDocumentToCsv(data, filename) {
    downloadFile(exportDocumentToCsv(data, filename), `${filename}.csv`, 'text/csv');
}
